var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 4.66667C1.5 2.91777 2.91777 1.5 4.66667 1.5H11.3333C13.0822 1.5 14.5 2.91777 14.5 4.66667V11.3333C14.5 13.0822 13.0822 14.5 11.3333 14.5H4.66667C2.91777 14.5 1.5 13.0822 1.5 11.3333V4.66667ZM4.66667 2.5C3.47005 2.5 2.5 3.47005 2.5 4.66667V11.3333C2.5 12.53 3.47005 13.5 4.66667 13.5H11.3333C12.53 13.5 13.5 12.53 13.5 11.3333V4.66667C13.5 3.47005 12.53 2.5 11.3333 2.5H4.66667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16667 5.33333C4.16667 4.689 4.689 4.16667 5.33333 4.16667H10.6667C11.311 4.16667 11.8333 4.689 11.8333 5.33333V10.6667C11.8333 11.311 11.311 11.8333 10.6667 11.8333H5.33333C4.689 11.8333 4.16667 11.311 4.16667 10.6667V5.33333ZM5.33333 5.16667C5.24129 5.16667 5.16667 5.24129 5.16667 5.33333V10.6667C5.16667 10.7587 5.24129 10.8333 5.33333 10.8333H10.6667C10.7587 10.8333 10.8333 10.7587 10.8333 10.6667V5.33333C10.8333 5.24129 10.7587 5.16667 10.6667 5.16667H5.33333Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 7C6.66667 6.81591 6.81591 6.66667 7 6.66667H9C9.18409 6.66667 9.33333 6.81591 9.33333 7V9C9.33333 9.18409 9.18409 9.33333 9 9.33333H7C6.81591 9.33333 6.66667 9.18409 6.66667 9V7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogic);
export default __webpack_public_path__ + "static/media/logic.4d138e941fad24276b2326eb780c666f.svg";
export { ForwardRef as ReactComponent };